import React, {Component} from 'react';
import {connect} from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Preloader from '../../components/preloader';
import ReferentialIntegrityTab from './components/ReferentialIntegrityTab';
import {loadInstances} from './dependency-analysis.actions';
import './dependency-analysis.scss';

class DependencyAnalysis extends Component {
  constructor(props) {
    super(props);
    this.state = {activeTab: 'ri'};
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
    this.props.loadInstances();
  }

  handleTabChange(e, val) {
    this.setState({activeTab: val});
  }

  render() {
    const {isLoading, auth} = this.props;
    const {activeTab} = this.state;
    const globalLoading = isLoading.includes('loadInstances');

    return (
      <div className="app-content-container da-page">
        <div className="page-content results-container in">
          <div className="da-page-header">
            <h2>Dependency Analysis</h2>
          </div>

          <Tabs value={activeTab} onChange={this.handleTabChange}>
            <Tab label="Referential Integrity" value="ri" data-testid="dependency-analysis-tab-ri" />
            <Tab
              label="Impact Analysis (coming soon)"
              value="impact"
              data-testid="dependency-analysis-tab-impact"
              disabled
            />
          </Tabs>

          {globalLoading && <Preloader loading />}

          {!globalLoading && activeTab === 'ri' && (
            <div className="da-tab-content">
              <ReferentialIntegrityTab auth={auth} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.dependencyAnalysis.isLoading,
});

const mapDispatchToProps = {loadInstances};

export default connect(mapStateToProps, mapDispatchToProps)(DependencyAnalysis);
